import React, { useEffect, useState } from 'react';
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import styled from 'styled-components';
import { getAssetsCurrentAndTargetList } from '../../api/allocationApi';
import { useMaterialUIController } from 'context';
import useMediaQuery from '@mui/material/useMediaQuery';

function AlocacaoPorAtivo() {
    const [data, setData] = useState([]);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const isMobile = useMediaQuery("(max-width:900px)", { noSsr: true });
    const minChartWidth = isMobile ? Math.max(520, data.length * 72) : "100%";

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        await getAssetsCurrentAndTargetList()
            .then(res => setData(res?.map(e => {
                return {
                    ativo: e.asset,
                    atual: e.currentPercentage,
                    meta: e.targetPercentage,
                    // valorAtual: 2, 
                    // valorMeta: 3
                }
            })))
    }

    return (
        <ChartScroller>
            <ChartFrame style={{ minWidth: minChartWidth }}>
                <StyledResponsiveContainer width="100%" height="100%" className="bars-chart-resp" $isDarkMode={darkMode}>
                    <BarChart
                        barCategoryGap={isMobile ? '22%' : '35%'}
                        width={500}
                        height={300}
                        data={data}
                        margin={{
                            top: 12,
                            right: isMobile ? 12 : 30,
                            left: isMobile ? 0 : 20,
                            bottom: isMobile ? 42 : 5,
                        }}
                        
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="ativo"
                            interval={0}
                            angle={isMobile ? -32 : 0}
                            textAnchor={isMobile ? "end" : "middle"}
                            height={isMobile ? 70 : 30}
                            tick={{ fontSize: isMobile ? 11 : 12 }}
                        />
                        <YAxis width={isMobile ? 34 : 45} tick={{ fontSize: isMobile ? 11 : 12 }} />
                        <Tooltip 
                            formatter={(value) => `${value}%`}
                        />

                        {/* <Tooltip 
                        content={({ payload, label }) => {
                            if (!payload || payload.length === 0) return null;

                            const { atual, meta, valorAtual, valorMeta } = payload[0].payload;

                            return (
                                <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                                    <p><strong>{label}</strong></p>
                                    <p>Atual: {atual}%</p>
                                    <p>Meta: {meta}%</p>
                                    <p>Valor Atual: R$ {valorAtual?.toFixed(2)}</p>
                                    <p>Valor Meta: R$ {valorMeta?.toFixed(2)}</p>
                                </div>
                            );
                        }}
                    /> */}
                        <Legend formatter={(value) => value === "atual" ? "Atual" : value === "meta" ? "Meta" : value} />

                        <Bar dataKey="atual" fill="#8884d8" activeBar={<Rectangle fill="#8884d8" stroke="black" />} />
                        <Bar dataKey="meta" fill="#82ca9d" activeBar={<Rectangle fill="#82ca9d" stroke="black" />} />
                        
                    </BarChart>
                </StyledResponsiveContainer>
            </ChartFrame>
        </ChartScroller>
    );
}

const ChartScroller = styled.div`
    width: 100%;
    overflow-x: auto;
    padding-bottom: 4px;
`;

const ChartFrame = styled.div`
    width: 100%;
    height: 600px;

    @media (max-width: 900px) {
        height: 380px;
    }
`;

const StyledResponsiveContainer = styled(ResponsiveContainer)`
    .recharts-text.recharts-cartesian-axis-tick-value tspan{
        fill: ${({ $isDarkMode }) => ($isDarkMode ? "#ffffffcc" : "#344767")};
    }

    // g.recharts-layer.recharts-bar-rectangle path.recharts-rectangle{
    //     transform: scaleX(0.5);
    // }
`;

export default AlocacaoPorAtivo;
